
      import API from "!../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.105.4_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.105.4_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.105.4_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.105.4_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.105.4_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.105.4_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4_webpack-cli@5.1.4_/node_modules/css-loader/dist/cjs.js!./ObservationPhoto.style.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4_webpack-cli@5.1.4_/node_modules/css-loader/dist/cjs.js!./ObservationPhoto.style.css";
       export default content && content.locals ? content.locals : undefined;
